<template>
    <div>
        <h1>Welcome back!</h1>
    </div>
  </template>
  <style scoped></style>
  <script>
  </script>
  
  
  <script>
    
    import { defineComponent } from 'vue';
    
    export default defineComponent({
      name: "LinkOauthReturnView",
      components: {
      },
      data() {
 
        },
        methods: {

        },
        created() {
        },
    });
    </script>
  